import { SharedAppThunk } from "./SharedAppThunk";
import * as types from "../../../Client/redux/actions/actionTypes";
import { NotificationInfo } from "../../sharedTypes";
import { SnackbarKey } from "notistack";

export function enqueueSnackbar(notification: NotificationInfo): SharedAppThunk {
    return function (dispatch, getState) {
        dispatch(enqueueSnackbarComplete(notification));
    };
}

const enqueueSnackbarComplete = (notification: NotificationInfo) => {
    const key = notification.options && notification.options.key;

    return {
        type: types.ENQUEUE_SNACKBAR as typeof types.ENQUEUE_SNACKBAR,
        notification: {
            ...notification,
            key: key || new Date().getTime() + Math.random(),
        } as NotificationInfo,
    };
};

export function closeSnackbar(key: SnackbarKey): SharedAppThunk {
    return function (dispatch, getState) {
        dispatch(closeSnackbarComplete(key));
    };
}

const closeSnackbarComplete = (key: SnackbarKey) => ({
    type: types.CLOSE_SNACKBAR as typeof types.CLOSE_SNACKBAR,
    dismissAll: !key as boolean, // dismiss all if no key has been defined
    key,
});

export function removeSnackbar(key: SnackbarKey): SharedAppThunk {
    return function (dispatch, getState) {
        dispatch(removeSnackbarComplete(key));
    };
}

const removeSnackbarComplete = (key: SnackbarKey) => ({
    type: types.REMOVE_SNACKBAR as typeof types.REMOVE_SNACKBAR,
    key,
});

export type NotificationActions =
    | ReturnType<typeof enqueueSnackbarComplete>
    | ReturnType<typeof closeSnackbarComplete>
    | ReturnType<typeof removeSnackbarComplete>;
